<template>
  <v-container fluid class="px-0">
    <v-row class="mb-3">
      <v-col cols="12" md="6">
        <el-text-field
          label="Identifikavimo kodas"
          tooltip="Hipoteka. Turtas. Ginklas. Identifikavimo kodas"
          :readonly="turtasReadonly || !sudarymas"
          :counter="50"
          v-model="formData.tur_identifikatorius"
          :autofocus="!turtasReadonly && sudarymas"
        />
      </v-col>
      <v-col cols="12" md="6">
        <el-text-field
          label="Ginklo numeris"
          tooltip="Hipoteka. Turtas. Ginklas. Ginklo numeris"
          :readonly="turtasReadonly"
          :counter="200"
          v-model="formData.tur_ginklas_numeris"
        />
      </v-col>
      <v-col cols="12" md="6">
        <el-text-field
          label="Ginklo modelis"
          tooltip="Hipoteka. Turtas. Ginklas. Ginklo modelis"
          :readonly="turtasReadonly"
          :counter="200"
          v-model="formData.tur_ginklas_modelis"
        />
      </v-col>
      <v-col cols="12" md="6">
        <el-text-field
          label="Ginklo rūšis"
          tooltip="Hipoteka. Turtas. Ginklas. Ginklo rūšis"
          :readonly="turtasReadonly"
          :counter="200"
          v-model="formData.tur_ginklas_rusis"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'TurtasGinklas',
  props: {
    formData: Object,
    readonly: Boolean,
    irasomas: Boolean,
    sudarymas: Boolean,
  },
  inject: {
    $validator: '$validator',
  },
  computed: {
    turtasReadonly() {
      return this.readonly || !this.irasomas
    },
  },
}
</script>
